import { useQuery } from "@tanstack/react-query";
import axios from "../../axiosConfig";
import { GET_PRODUCT_FAMILY_NAMES } from "../queries/GetProductFamilies";

const fetchProductFamilyNames = async ({ queryKey }) => {
    const [, { token }] = queryKey;

    if (!token) throw new Error("Token not available");

    try {
        const response = await axios.get(`/getProductFamilyNames`, {
            headers: { Authorization: token },
        });

        return response.data;
    } catch (error) {
        throw new Error(error.response?.data || "Error fetching data");
    }
};

export const useGetProductFamilyNames = (token) => {
    return useQuery({
        queryKey: [GET_PRODUCT_FAMILY_NAMES, { token }],
        queryFn: fetchProductFamilyNames,
        enabled: !!token, 
        retry: false, 
    });
};
